/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * サイト設定。
 * ファンレターリンクはダッシュボード画面にて不正な値が入力される可能性があるため、String型で対応。
 * @export
 * @interface SiteSettingModel
 */
export interface SiteSettingModel {
    /**
     * タイトル
     * @type {string}
     * @memberof SiteSettingModel
     */
    name?: string;
    /**
     * キャッチコピー
     * @type {string}
     * @memberof SiteSettingModel
     */
    catchCopy?: string;
    /**
     * メタキーワード
     * @type {string}
     * @memberof SiteSettingModel
     */
    metaKeyword?: string;
    /**
     * メタディスクリプション
     * @type {string}
     * @memberof SiteSettingModel
     */
    metaDescription?: string;
    /**
     * ファビコンURL
     * @type {string}
     * @memberof SiteSettingModel
     */
    faviconUrl?: string;
    /**
     * アップルタッチアイコンURL
     * @type {string}
     * @memberof SiteSettingModel
     */
    appleTouchIconUrl?: string;
    /**
     * OGP画像
     * @type {string}
     * @memberof SiteSettingModel
     */
    ogpImageUrl?: string;
    /**
     * ファンレターリンク
     * @type {string}
     * @memberof SiteSettingModel
     */
    fanLetterLink?: string;
    /**
     * PC用ロゴ画像URL
     * @type {string}
     * @memberof SiteSettingModel
     */
    logoImageUrl?: string;
    /**
     * フッター用ロゴ画像URL
     * @type {string}
     * @memberof SiteSettingModel
     */
    footerLogoImageUrl?: string;
    /**
     * スマートニュース用ロゴ画像URL
     * @type {string}
     * @memberof SiteSettingModel
     */
    smartNewsLogoImageUrl?: string;
    /**
     * スマホ用ロゴ画像URL
     * @type {string}
     * @memberof SiteSettingModel
     */
    spLogoImageUrl?: string;
    /**
     * 未ログインユーザーがガチャを引いた際に結果として表示するチケット枚数。会員登録ボーナスで獲得できるチケット枚数が設定されます
     * @type {number}
     * @memberof SiteSettingModel
     */
    guestUserGachaBonus?: number;
}

/**
 * Check if a given object implements the SiteSettingModel interface.
 */
export function instanceOfSiteSettingModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SiteSettingModelFromJSON(json: any): SiteSettingModel {
    return SiteSettingModelFromJSONTyped(json, false);
}

export function SiteSettingModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteSettingModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'catchCopy': !exists(json, 'CatchCopy') ? undefined : json['CatchCopy'],
        'metaKeyword': !exists(json, 'metaKeyword') ? undefined : json['metaKeyword'],
        'metaDescription': !exists(json, 'metaDescription') ? undefined : json['metaDescription'],
        'faviconUrl': !exists(json, 'faviconUrl') ? undefined : json['faviconUrl'],
        'appleTouchIconUrl': !exists(json, 'appleTouchIconUrl') ? undefined : json['appleTouchIconUrl'],
        'ogpImageUrl': !exists(json, 'ogpImageUrl') ? undefined : json['ogpImageUrl'],
        'fanLetterLink': !exists(json, 'fanLetterLink') ? undefined : json['fanLetterLink'],
        'logoImageUrl': !exists(json, 'logoImageUrl') ? undefined : json['logoImageUrl'],
        'footerLogoImageUrl': !exists(json, 'footerLogoImageUrl') ? undefined : json['footerLogoImageUrl'],
        'smartNewsLogoImageUrl': !exists(json, 'smartNewsLogoImageUrl') ? undefined : json['smartNewsLogoImageUrl'],
        'spLogoImageUrl': !exists(json, 'spLogoImageUrl') ? undefined : json['spLogoImageUrl'],
        'guestUserGachaBonus': !exists(json, 'guestUserGachaBonus') ? undefined : json['guestUserGachaBonus'],
    };
}

export function SiteSettingModelToJSON(value?: SiteSettingModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'CatchCopy': value.catchCopy,
        'metaKeyword': value.metaKeyword,
        'metaDescription': value.metaDescription,
        'faviconUrl': value.faviconUrl,
        'appleTouchIconUrl': value.appleTouchIconUrl,
        'ogpImageUrl': value.ogpImageUrl,
        'fanLetterLink': value.fanLetterLink,
        'logoImageUrl': value.logoImageUrl,
        'footerLogoImageUrl': value.footerLogoImageUrl,
        'smartNewsLogoImageUrl': value.smartNewsLogoImageUrl,
        'spLogoImageUrl': value.spLogoImageUrl,
        'guestUserGachaBonus': value.guestUserGachaBonus,
    };
}

